export function trimHexValue(hexValue: string): string {
  if (hexValue.length === 9) {
    const trimmedValue = hexValue.slice(0, 7);
    return trimmedValue;
  } else {
    return hexValue; // Return the input as-is if it's not 8 characters long
  }
}
